<app-loading *ngIf="viewModel?.isCombinedLoading$ | async" [options]="viewModel?.combinedLoadingOpts$ | async">
</app-loading>

<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="'template-publish'" [stickyZ]="2" [stickyOrder]="0">
    <div class="modal-header no-bottom-border pb-none" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="modal-title mb-28px" ngbAutofocus>Publish Template</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div
      #contentContainer
      libStickyAutoPosition
      [stickyCollectionKey]="'template-publish'"
      [stickyZ]="2"
      [stickyOrder]="1"
      [style.background-color]="'white'">
      <div class="desc-and-search" fxLayout="column" [style.gap.rem]="1">
        <div class="modal-description">
          <p>Are you sure you want to publish this?</p>
          <ng-container [ngSwitch]="(viewModel.requiredLocationIds$ | async)?.length > 0">
            <p *ngSwitchCase="true">
              A published template can be used by your locations. This templated menu will automatically be created at
              the following required locations:
            </p>
            <p *ngSwitchCase="false">
              A published template can be used by your locations. No required locations for this template have been set.
            </p>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="template-publish-location-container">
      <ng-container
        *ngFor="
          let grouping of viewModel.requiredLocationsGroupedByProvince$ | async | keyvalue;
          trackBy: viewModel.trackById
        ">
        <ng-container [ngSwitch]="viewModel.singleRequiredProvince$ | async">
          <ng-container *ngSwitchCase="true">
            <div *ngFor="let location of grouping.value | locationsOnly" class="location-container">
              <app-template-location-info-text [location]="location"> </app-template-location-info-text>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="false">
            <app-template-location-selection-group
              [viewOnlyMode]="true"
              [expanded]="true"
              [province]="grouping?.key"
              [locations]="grouping?.value">
            </app-template-location-selection-group>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary (buttonClicked)="viewModel.publishTemplate()"> Publish Template </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
